import React, { useEffect, useState } from "react";
import { Button, Stack } from "react-bootstrap";
// Icons
import * as AiIcons from "react-icons/ai";
import { useAuth } from "../../Context/AuthContext";
import { ApiEndpoint } from "../../utils/ApiEndpoint";
import { httpClient } from "../../utils/HttpClient";
import ModalEdit from "../../components/ModalEdit";
import Confirm from "../../components/Confirm";
import CreateTemplate from "./_CreateTemplate";
import { Table } from '../../components/ui/Table'

const ExternalTemplates = () => {
  const Auth = useAuth();

  const [templates, setTemplates] = useState([]);
  const [idToDeleteTemplate, setIdToDeleteTemplate] = useState(null);
  const handleShow = () => setShow(true);
  const [show, setShow] = useState(false);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);

  const handleClose = () => {
    getPartnerTemplates();
    setShow(false);
    setShowConfirmDelete(false);
  };

  const handleConfirm = () => {
    deleteEndpoint();
    setShowConfirmDelete(false);
  };

  const deleteEndpoint = () => {
    console.log(idToDeleteTemplate);
    var userData = Auth.getSessionData();
    if (idToDeleteTemplate > 0) {
      httpClient(
        "DELETE",
        ApiEndpoint +
          "partner/externaltemplate/" +
          userData.uid_partner +
          "/" +
          idToDeleteTemplate,
        {},
        userData.token
      )
        .then(function (response) {
          console.log(response);
          handleClose();
          return;
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  const columns = [
    {
      accessor: "name",
      Header: "Template",
    },
    {
      accessor: "message",
      Header: "Mensaje",
    },

    {
      accessor: "none",
      Header: "Acciones",
      disableSortBy: true,
      headerProps: {
        className: "text-center",
      },
      cellProps: {
        className: "text-center",
      },
      Cell: (rowData) => {
        let id = rowData.row.original.idexternaltemplate;
        return (
          <>
            {id > 0 && (
              <>
                |
                <AiIcons.AiFillDelete
                  className="IconTable"
                  title="Eliminar"
                  onClick={() => {
                    setIdToDeleteTemplate(id);
                    setShowConfirmDelete(true);
                  }}
                />
              </>
            )}
          </>
        );
      },
    },
  ];

  const getPartnerTemplates = () => {
    var userData = Auth.getSessionData();
    const URI =
      ApiEndpoint + "partner/externaltemplates/" + userData.uid_partner;
    httpClient("GET", URI, {}, userData.token).then((response) => {
      var templates = response.data;

      setTemplates(templates);
    });
  };

  useEffect(() => {
    getPartnerTemplates();
  }, []);


  return (
    <>
      <div className="">
        <Stack direction="horizontal" gap={2}>
          <div>
            <h2>Templates Externos</h2>
            <h3>Administre templates externos</h3>
          </div>
          <div className="ms-auto">
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => {
                //setIdCustomer(0);
                setShow(true);
              }}
            >
              {" "}
              <AiIcons.AiOutlinePlus /> Agregar
            </Button>
          </div>
        </Stack>
        <div className="bg-white rounded-lg p-4 min-h-50 min-w-full">
          <Table
            columns={columns}
            data={templates}
            config={{
              sortable: true,
              pagination: true,
              perPage: 10,
              pageSize: 10,
              search: true,
              footer: true,
              infoSize: "xl",
              iconInfoSize: 30,
            }}
            loading={!templates.length}
          />
        </div>
      </div>
      <ModalEdit
        show={show}
        handleShow={handleShow}
        handleClose={handleClose}
        title="Agregar Template Externo"
      >
        <CreateTemplate handleClose={handleClose}></CreateTemplate>
      </ModalEdit>
      <Confirm
        show={showConfirmDelete}
        handleClose={handleClose}
        handleConfirm={handleConfirm}
        message={"¿Desea eliminar este template?"}
      />
    </>
  );
};

export default ExternalTemplates;
